function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from '../ModalCommon.pcss';
var _React_PureComponent;
class ConfirmDataSharingModal extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress && !state.isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        if (this.props.openModalId !== constants.APPROVE_DATA_SHARING_MODAL) {
            return;
        }
        const { isInProgress, hasErrors } = this.props;
        if (isInProgress !== prevProps.isInProgress && !isInProgress && !hasErrors) {
            this.onClose();
        }
    }
    onApproveDataSharing(sharingRequest) {
        const { isInProgress, phiSet, activeProfile } = this.props;
        const { phiSetReferenceKey, encryptedExchangeToken } = activeProfile || {};
        if (isInProgress || !encryptedExchangeToken || !phiSetReferenceKey) {
            return;
        }
        this.props.onApprove(sharingRequest, activeProfile, phiSet);
    }
    async onClose() {
        await this.props.onCloseModal();
        this.setState({
            isInProgress: false
        });
    }
    get sharingRequest() {
        return find(this.props.sharingRequests, {
            sharingRequestId: this.props.beingApprovedSharingRequestId
        });
    }
    renderActions(sharingRequest) {
        const { sharingStatus } = sharingRequest;
        const isApproved = sharingStatus === 'Approved';
        return /*#__PURE__*/ _jsxs("div", {
            className: "modal__actions row flex-wrap-reverse",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6 mt-4 mt-sm-0",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "quaternary",
                        labelMessage: isApproved ? messages.buttons.decline : messages.buttons.noDeclineInvitation,
                        className: "btn--block",
                        isDisabled: this.state.isInProgress,
                        onClick: this.props.onCloseModal
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: isApproved ? messages.buttons.accept : messages.buttons.yesShareData,
                        className: "btn--block btn--filled",
                        // onClick={() => this.onConfirmDataSharing()}
                        isInProgress: this.state.isInProgress,
                        onClick: ()=>this.onApproveDataSharing(sharingRequest)
                    })
                })
            ]
        });
    }
    renderAvatar(sharingRequest) {
        const avatar = sharingRequest.hcp ? sharingRequest.hcp.avatar : sharingRequest.clinic.logo;
        const avatarName = sharingRequest.hcp ? [
            sharingRequest.hcp.firstName,
            sharingRequest.hcp.lastName
        ] : sharingRequest.clinic.name;
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: avatar,
            name: avatarName,
            className: styles.item__avatar,
            imgClassName: styles.item__avatar__img,
            initialsClassName: styles.item__avatar__initials
        });
    }
    renderHcpDetails(sharingRequest) {
        const hcpName = sharingRequest.hcp ? `${sharingRequest.hcp.firstName} ${sharingRequest.hcp.lastName}` : sharingRequest.clinic.name;
        return /*#__PURE__*/ _jsx("b", {
            children: hcpName
        });
    }
    renderPerson(sharingRequest) {
        const hcpName = sharingRequest.hcp ? `${sharingRequest.hcp.firstName} ${sharingRequest.hcp.lastName}` : sharingRequest.clinic.name;
        const clinicName = sharingRequest.hcp ? sharingRequest.clinic.name : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.unassigned));
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('d-flex my-5 align-items-center', styles.person),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: this.renderAvatar(sharingRequest)
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: styles.person__name,
                            children: hcpName
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text--small text--light",
                            children: clinicName
                        })
                    ]
                })
            ]
        });
    }
    render() {
        if (!this.props.activeProfile || !this.props.activeProfile.phiSetReferenceKey) {
            return null;
        }
        const { sharingRequest } = this;
        if (!sharingRequest) {
            return null;
        }
        const { sharingStatus } = sharingRequest;
        const isApproved = sharingStatus === 'Approved';
        const headerMessage = isApproved ? messages.headers.reauthorizeDataSharing : messages.headers.confirmDataSharing;
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.APPROVE_DATA_SHARING_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: headerMessage,
            styleModifier: "md",
            isInProgress: this.state.isInProgress,
            onClose: this.props.shouldCloseOnlyViaActionButton ? null : this.props.onCloseModal,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.container,
                    children: [
                        isApproved ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.areYouSureToReauthorizeData), {
                            values: {
                                hcpDetails: this.renderHcpDetails(sharingRequest)
                            }
                        })) : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.areYouSureToShareData)),
                        this.renderPerson(sharingRequest)
                    ]
                }),
                this.renderActions(sharingRequest)
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
    }
}
_define_property(ConfirmDataSharingModal, "propTypes", {
    // Explicit props
    activeProfile: PropTypes.shape({
        patientProfileId: PropTypes.number,
        phiSetReferenceKey: PropTypes.string,
        storageProvider: PropTypes.string
    }),
    shouldCloseOnlyViaActionButton: PropTypes.bool,
    // Implicit props
    sharingRequests: PropTypes.arrayOf(shapes.sharingRequest),
    beingApprovedSharingRequestId: PropTypes.number,
    openModalId: PropTypes.string,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    phiSet: PropTypes.object,
    // Implicit actions
    onApprove: PropTypes.func,
    onCloseModal: PropTypes.func
});
const mapStateToProps = (state)=>{
    const sharingRequestId = selectors.beingApprovedSharingRequestId(state);
    return {
        sharingRequests: selectors.sharingRequests(state),
        phiSet: selectors.phiSet(state),
        beingApprovedSharingRequestId: sharingRequestId,
        isInProgress: selectors.isApproveSharingRequestInProgressSelector(sharingRequestId)(state),
        hasErrors: selectors.hasApproveSharingRequestErrorsSelector(sharingRequestId)(state),
        openModalId: App.selectors.modal(state)
    };
};
const mapDispatchToProps = (dispatch)=>({
        onApprove: (sharingRequest, patientProfile, phiSet)=>dispatch(actions.approveSharingRequest(sharingRequest, patientProfile, phiSet)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedConfirmDataSharingModal = connect(mapStateToProps, mapDispatchToProps)(ConfirmDataSharingModal);
export default withStyles(styles)(ConnectedConfirmDataSharingModal);
